import Navbar from "./Navbar";
import Footer from "./Footer";
import AnnouncementBar from "./AnnouncementBar";
import TawkTo from "./TawkTo";
import WhatsAppFab from "./WhatsAppFab";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <TawkTo />
      <WhatsAppFab />
    </div>
  );
}
